import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import PackageForm from './PackageForm';

const PackagesListView = ({ navigate, setEditingPackageId, setNewPackage, loading, packages, editPackage, deletePackage }) => (
  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 font-sans">
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
      <div className="flex items-center gap-4">
        <button 
          onClick={() => navigate('/admin')} 
          className="w-fit flex items-center gap-1.5 text-black font-bold uppercase tracking-[0.2em] text-[10px] transition-all bg-gray-50 px-3 py-2 rounded-lg border border-gray-100 hover:bg-black hover:text-white"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
          </svg>
          Nazad
        </button>
        <h2 className="text-xl font-black text-black tracking-tight">Lista Paketa</h2>
      </div>
      
      <button 
        className="w-fit bg-black text-white px-5 py-2.5 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-gray-800 transition-all font-sans" 
        onClick={() => {
          setEditingPackageId(null);
          setNewPackage({
            naziv: { bs: '', en: '' }, opis: { bs: '', en: '' }, trajanje: { bs: '', en: '' }, cijena: '', valuta: 'BAM', usluge: [], slika: '', prikaziNaNaslovnoj: false
          });
          navigate('add');
        }}
      >
        + Novi Paket
      </button>
    </div>
    
    {loading ? <p className="text-black text-center py-8">Učitavanje...</p> : (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.length === 0 && (
            <div className="text-center py-8 text-black col-span-full">Nema unesenih paketa.</div>
          )}

          {packages.map((pkg) => (
            <div key={pkg.firestoreId} className={`bg-white rounded-xl p-5 border transition-all hover:border-black`}> 
              <div className="flex justify-between items-start mb-4">
                <div className="min-w-0">
                  <h3 className="font-black text-black text-lg leading-tight truncate">{typeof pkg.naziv === 'object' ? pkg.naziv.bs : pkg.naziv}</h3>
                  {pkg.naziv?.en && <p className="text-xs text-black mt-1">{pkg.naziv.en}</p>}
                </div>
                <div>
                  {pkg.prikaziNaNaslovnoj ? (
                    <span className="bg-green-100 text-green-700 text-xs font-medium px-2 py-1 rounded">Na Naslovnoj</span>
                  ) : (
                    <span className="bg-gray-100 text-black text-xs font-medium px-2 py-1 rounded">Skriveno</span>
                  )}
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div>
                  <label className="text-[9px] font-bold text-black uppercase tracking-widest block mb-1">Cijena</label>
                  <div className="font-black text-black text-base">{pkg.cijena} {pkg.valuta}</div>
                </div>
                {pkg.opis && (
                  <p className="text-sm text-black line-clamp-3">{typeof pkg.opis === 'object' ? pkg.opis.bs : pkg.opis}</p>
                )}
              </div>

              <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
                <button onClick={() => editPackage(pkg)} className="flex-1 px-3 py-2 bg-white text-black border border-gray-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-all">Uredi</button>
                <button onClick={() => deletePackage(pkg.firestoreId)} className="w-10 h-10 flex items-center justify-center bg-red-50 text-red-400 rounded-lg hover:bg-black hover:text-white transition-all border border-transparent">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
    )}
  </div>
);

const PackageFormView = ({ navigate, setEditingPackageId, setNewPackage, editingPackageId, handlePackageSubmit, newPackage, handlePackageInputChange, currentServiceBs, setCurrentServiceBs, currentServiceEn, setCurrentServiceEn, addServiceToPackage, removeServiceFromPackage }) => (
  <div className="bg-transparent max-w-4xl mx-auto font-sans">
    <div className="flex items-center gap-4 mb-8 px-4">
        <button 
          onClick={() => {
              setEditingPackageId(null);
              setNewPackage({
                naziv: { bs: '', en: '' }, opis: { bs: '', en: '' }, trajanje: { bs: '', en: '' }, cijena: '', valuta: 'BAM', usluge: [], slika: '', prikaziNaNaslovnoj: false
              });
              navigate('/admin/packages');
          }}
          className="w-fit flex items-center gap-1.5 text-black font-bold uppercase tracking-[0.2em] text-[10px] transition-all bg-gray-50 px-3 py-2 rounded-lg border border-gray-100 hover:bg-black hover:text-white"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
          </svg>
          Nazad
        </button>
        <h3 className="text-xl font-black text-black tracking-tight">{editingPackageId ? 'Uredi paket' : 'Dodaj novi paket'}</h3>
    </div>

    <PackageForm 
      editingPackageId={editingPackageId}
      handlePackageSubmit={async (e) => {
          await handlePackageSubmit(e);
          navigate('/admin/packages');
      }}
      newPackage={newPackage}
      setNewPackage={setNewPackage}
      handlePackageInputChange={handlePackageInputChange}
      currentServiceBs={currentServiceBs}
      setCurrentServiceBs={setCurrentServiceBs}
      currentServiceEn={currentServiceEn}
      setCurrentServiceEn={setCurrentServiceEn}
      addServiceToPackage={addServiceToPackage}
      removeServiceFromPackage={removeServiceFromPackage}
      setEditingPackageId={setEditingPackageId}
      cancelEdit={() => {
          setEditingPackageId(null);
          setNewPackage({
            naziv: { bs: '', en: '' }, opis: { bs: '', en: '' }, trajanje: { bs: '', en: '' }, cijena: '', valuta: 'BAM', usluge: [], slika: '', prikaziNaNaslovnoj: false
          });
          navigate('/admin/packages');
      }}
    />
  </div>
);

const AdminPackages = ({
  editingPackageId,
  handlePackageSubmit,
  newPackage,
  setNewPackage,
  handlePackageInputChange,
  currentServiceBs,
  setCurrentServiceBs,
  currentServiceEn,
  setCurrentServiceEn,
  addServiceToPackage,
  removeServiceFromPackage,
  setEditingPackageId,
  loading,
  packages,
  editPackage,
  deletePackage
}) => {
  const navigate = useNavigate();

  // URL Sync Effect
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/edit/') && !editingPackageId && packages.length > 0) {
      const idFromPath = path.split('/edit/')[1];
      const pkgToEdit = packages.find(p => p.firestoreId === idFromPath);
      if (pkgToEdit) editPackage(pkgToEdit);
    }
  }, [packages, editingPackageId, editPackage]);

  return (
    <Routes>
      <Route path="/" element={<PackagesListView navigate={navigate} setEditingPackageId={setEditingPackageId} setNewPackage={setNewPackage} loading={loading} packages={packages} editPackage={editPackage} deletePackage={deletePackage} />} />
      <Route path="/add" element={<PackageFormView navigate={navigate} setEditingPackageId={setEditingPackageId} setNewPackage={setNewPackage} editingPackageId={editingPackageId} handlePackageSubmit={handlePackageSubmit} newPackage={newPackage} handlePackageInputChange={handlePackageInputChange} currentServiceBs={currentServiceBs} setCurrentServiceBs={setCurrentServiceBs} currentServiceEn={currentServiceEn} setCurrentServiceEn={setCurrentServiceEn} addServiceToPackage={addServiceToPackage} removeServiceFromPackage={removeServiceFromPackage} />} />
      <Route path="/edit/:id" element={<PackageFormView navigate={navigate} setEditingPackageId={setEditingPackageId} setNewPackage={setNewPackage} editingPackageId={editingPackageId} handlePackageSubmit={handlePackageSubmit} newPackage={newPackage} handlePackageInputChange={handlePackageInputChange} currentServiceBs={currentServiceBs} setCurrentServiceBs={setCurrentServiceBs} currentServiceEn={currentServiceEn} setCurrentServiceEn={setCurrentServiceEn} addServiceToPackage={addServiceToPackage} removeServiceFromPackage={removeServiceFromPackage} />} />
    </Routes>
  );
};

export default AdminPackages;
